export default "__VITE_ASSET__CRC_3Reh__"